import React from 'react';
import styles from './index.modules.scss';
import { Image as MImage } from '@mantine/core';
import fallbackImage from './assets/shakker_fallback.svg';

/**
 * 参见https://mantine.dev/core/image/
 *
 * @param {*} props
 * @returns
 */
export const Image = (props) => {
  const { src, children, radius = 'rounded-lg', ...rest } = props;

  return (
    <picture className={styles.image}>
      <MImage {...rest} radius={radius} src={src} fallbackSrc={fallbackImage} />
      {children}
    </picture>
  );
};
